/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetApplicantsResponse,
  GetCohortsResponse,
  HTTPValidationError,
} from './platformapi.schemas';

import getApplicantsMutator from '../custom-axios-instance';
import getClientCohortsMutator from '../custom-axios-instance';

/**
 * Get a list of professionals who have applied to work with the corporate client.
 * @summary Get Applicants
 */
export const getApplicants = (cohortId: number, signal?: AbortSignal) => {
  return getApplicantsMutator<GetApplicantsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/corporate-admins/applications/${cohortId}`,
    method: 'GET',
    signal,
  });
};

export const getGetApplicantsQueryKey = (cohortId?: number) => {
  return [`${import.meta.env['VITE_API_HOST']}/corporate-admins/applications/${cohortId}`] as const;
};

export const getGetApplicantsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApplicants>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicants>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApplicantsQueryKey(cohortId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApplicants>>> = ({ signal }) =>
    getApplicants(cohortId, signal);

  return { queryKey, queryFn, enabled: !!cohortId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApplicants>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApplicantsQueryResult = NonNullable<Awaited<ReturnType<typeof getApplicants>>>;
export type GetApplicantsQueryError = void | HTTPValidationError;

export function useGetApplicants<
  TData = Awaited<ReturnType<typeof getApplicants>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicants>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicants>>,
          TError,
          Awaited<ReturnType<typeof getApplicants>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApplicants<
  TData = Awaited<ReturnType<typeof getApplicants>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicants>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicants>>,
          TError,
          Awaited<ReturnType<typeof getApplicants>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApplicants<
  TData = Awaited<ReturnType<typeof getApplicants>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicants>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Applicants
 */

export function useGetApplicants<
  TData = Awaited<ReturnType<typeof getApplicants>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicants>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApplicantsQueryOptions(cohortId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a list of cohorts associated with the corporate client.
 * @summary Get Client Cohorts
 */
export const getClientCohorts = (signal?: AbortSignal) => {
  return getClientCohortsMutator<GetCohortsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/corporate-admins/cohorts`,
    method: 'GET',
    signal,
  });
};

export const getGetClientCohortsQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/corporate-admins/cohorts`] as const;
};

export const getGetClientCohortsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientCohorts>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientCohorts>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientCohortsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientCohorts>>> = ({ signal }) =>
    getClientCohorts(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientCohorts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientCohortsQueryResult = NonNullable<Awaited<ReturnType<typeof getClientCohorts>>>;
export type GetClientCohortsQueryError = void | HTTPValidationError;

export function useGetClientCohorts<
  TData = Awaited<ReturnType<typeof getClientCohorts>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientCohorts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientCohorts>>,
          TError,
          Awaited<ReturnType<typeof getClientCohorts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientCohorts<
  TData = Awaited<ReturnType<typeof getClientCohorts>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientCohorts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientCohorts>>,
          TError,
          Awaited<ReturnType<typeof getClientCohorts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientCohorts<
  TData = Awaited<ReturnType<typeof getClientCohorts>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientCohorts>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Client Cohorts
 */

export function useGetClientCohorts<
  TData = Awaited<ReturnType<typeof getClientCohorts>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientCohorts>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientCohortsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
